export const CURRENCIES = ['USD', 'EUR', 'CNY', 'ARS', 'BRL', 'CLP', 'COP', 'JPY', 'MXN', 'GBP', 'UYU'] as const;
export type Currency = (typeof CURRENCIES)[number];

export const DEFAULT_ENABLED_CURRENCIES: readonly Currency[] = ['USD', 'ARS'];

export const isCurrency = (value: unknown): value is Currency =>
  typeof value === 'string' && (CURRENCIES as readonly string[]).includes(value);

/** A stored list, in canonical order, without unknowns or duplicates. */
export function normalizeEnabledCurrencies(value: unknown): Currency[] {
  if (!Array.isArray(value)) return [...DEFAULT_ENABLED_CURRENCIES];
  return CURRENCIES.filter((currency) => value.includes(currency));
}

/**
 * A currency pattern bakes in `$`; the code replaces it, since USD and ARS are
 * both dollars and `$` alone cannot tell them apart.
 */
export const withCurrencyCode = (formatted: string, currency: Currency | undefined): string =>
  currency ? formatted.replace('$', `${currency} `).trim() : formatted;
